<template>
  <div class="backStack-issue-wrap">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <UserInfos ref="userInfos" :infos="userInfo"></UserInfos>
    <div class="backStack-issue-footer-wrap">
      <div class="read-wrap">
        <a-checkbox v-model="isRead" @change="readChange"></a-checkbox>
        <span class="text">我已阅读并同意《需求发布规则》</span>
      </div>
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit">提交审核</a-button>
        <span class="text"
          >温馨提示：需求成果提交后，将由相关人员审核后，方可发布！</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import UserInfos from '../../components/userInfos/index.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formRules, formRows, userInfo } from './configs/formOptions.js'
import { editDemandInfos } from '@/api/demandIssue.js'
import { getDemandInfos } from '@/api/demandInfos.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      userInfo, // 数据
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {}, // 表单的默认值
      isRead: false,
      detailId: null // 详情的请求的id
    }
  },
  components: {
    From,
    UserInfos
  },
  created() {
    this.initSetting()
  },
  methods: {
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    // 获取默认值
    async initDefaultModel() {
      const { data } = await getDemandInfos(this.detailId)
      this.defaultModel = { ...data }
      this.dealInfo(data.user) // 处理用户信息
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!result) return
      if (!this[type]) return
      this[type].forEach(item => {
        const { key } = item
        const v = result[key] || '-'
        item.value = v
      })
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 参数处理
    beforeRequest() {
      const { detailId } = this
      const { inputValue, ...formValue } = this.$refs.formRef.formModel
      const userInfo = this.$refs.userInfos.model
      let params = { ...formValue, ...userInfo, id: detailId }
      params.orgType = this.selectValue
      if (inputValue) {
        // 单独处理自定义radio勾选框中的值
        params.priceRange = inputValue
      }
      return params
    },
    async toAudit() {
      const v = this.$refs.formRef.validatedForm()
      if (!v) return
      if (!this.isRead) {
        // 编辑状态下不检查这个勾选
        return this.$apiStatusHandler(1, '请勾选《需求发布规则》')
      }
      const params = this.beforeRequest()
      const { code, msg } = await editDemandInfos(params)
      this.$apiStatusHandler(code, msg)
      this.$router.push({ name: 'demandInfos', query: { key: 'demandInfos' } })
    }
  }
}
</script>
